import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';
import { templatesListKey } from '@services/useTemplatesListQuery';

import type { IApiError, IMutationTemplateResponse, ISaveTemplateData } from '../model/templateMutations';
import { equipmentSettingsLogListKey } from './useEquipmentSettingsLogListInfiniteQuery';

const saveTemplateFn = (data: ISaveTemplateData) =>
  apiClient.post(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/template`, data);

export const useSaveTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<IMutationTemplateResponse, AxiosError<IApiError>, ISaveTemplateData>({
    mutationFn: saveTemplateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [templatesListKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentSettingsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
